import classNames from 'classnames'
import style from 'components/Block.module.scss'
import camelCase from 'lodash/camelCase'
import React from 'react'

const Block = ({ children, typeHandle, backgroundColor, type }) => {
  // Determine the block class
  const className = classNames(
    style.root,

    style[`root___${camelCase(type)}`],
    {
      [style[`root___${typeHandle}`]]: typeHandle,
    }
  )

  return <div className={className}>{children}</div>
}

Block.defaultProps = {
  backgroundColor: 'transparent',
  typeHandle: null,
  children: [],
}

export default Block
